import type {FC} from 'react';
import {Outlet} from 'react-router-dom';
import ErrorsDialog from '@/components/common/ErrorsDialog';
import {useController} from './controller';

const ErrorBoundary: FC = () => {
  const {error, onClose} = useController();

  return (
    <>
      {error && <ErrorsDialog error={error} onClose={onClose} />}
      <Outlet />
    </>
  );
};
export default ErrorBoundary;
